import { LitElement, html, utils } from '@hh/global.js'

class HHHeader extends LitElement {
  EXIT_TIMEOUT = 500

  constructor() {
    super()

    this.triggers = this.querySelectorAll('.js-header-mega-menu-trigger')
    this.menuItems = this.querySelectorAll('.js-header-mega-menu-panel')
    this.overlay = this.querySelector('.js-header-mega-menu-overlay')
    this.stickyHeader = document.querySelector('hh-sticky-header')

    this.openMenu = this.openMenu.bind(this)
    this.closeMenu = this.closeMenu.bind(this)
    this.handleClickKeyboard = this.handleClickKeyboard.bind(this)
    this.handleMenuItemEnter = this.handleMenuItemEnter.bind(this)
    this.handleMenuItemLeave = this.handleMenuItemLeave.bind(this)

    this.setWindowsHeight()
    window.addEventListener('resize', () => this.setWindowsHeight())
  }

  connectedCallback() {
    super.connectedCallback()

    for (const trigger of this.triggers) {
      trigger.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') this.closeMenu(event)
      })
      trigger.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') this.openMenu(event)
      })
      trigger.addEventListener('pointerup', this.openMenu)
      trigger.addEventListener('keydown', this.handleClickKeyboard)
    }

    for (const menuItem of this.menuItems) {
      menuItem.addEventListener('pointerenter', this.handleMenuItemEnter)
      menuItem.addEventListener('pointerleave', this.handleMenuItemLeave)
    }

    this.overlay?.addEventListener('click', this.closeMenu)
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    for (const trigger of this.triggers) {
      trigger.removeEventListener('pointerleave', this.closeMenu)
      trigger.removeEventListener('pointerenter', this.openMenu)
      trigger.removeEventListener('pointerup', this.openMenu)
      trigger.removeEventListener('keydown', this.handleClickKeyboard)
    }

    for (const menuItem of this.menuItems) {
      menuItem.removeEventListener('pointerenter', this.handleMenuItemEnter)
      menuItem.removeEventListener('pointerleave', this.handleMenuItemLeave)
    }

    this.overlay?.removeEventListener('click', this.closeMenu)
  }

  setWindowsHeight() {
    document.querySelector('html')
      .style.setProperty('--hh-window-height', `${window.innerHeight}px`)
  }

  handleClickKeyboard(event) {
    if (event.key.toLowerCase() === 'arrowdown'
      || event.key.toLowerCase() === ' '
    ) {
      this.openMenu(event)
    }
  }

  handleMenuItemEnter() {
    this.clearExitTimer()
  }

  handleMenuItemLeave() {
    this.setExitTimer(false)
  }

  clearExitTimer() {
    try {
      clearTimeout(this.navLeaveTimer)
      this.navLeaveTimer = null
    } catch (error) {
      console.error(error)
    }
  }

  closeMenuItems() {
    this.activeMenuItem = null
    this.applyState()
  }

  setExitTimer(delay = true) {
    try {
      if (delay) {
        this.navLeaveTimer = setTimeout(() => {
          this.closeMenuItems()
        }, this.EXIT_TIMEOUT)
      } else {
        this.closeMenuItems()
      }
    } catch (error) {
      console.error(error)
    }
  }

  applyState() {
    for (const menuItem of this.menuItems) {
      if (this.activeMenuItem === menuItem) {
        menuItem.classList.add('active')
        menuItem.setAttribute('aria-hidden', false)
      } else {
        menuItem.classList.remove('active')
        menuItem.setAttribute('aria-hidden', true)
      }
    }
  }

  openMenu(event) {
    try {
      event.preventDefault()
      this.clearExitTimer()
      this.activeMenuItem = event.currentTarget?.closest('.header__menu-item--parent-wrapper')?.querySelector('.js-header-mega-menu-panel') || null
      this.stickyHeader.classList.add('hh-sticky-header--opened')
    } catch (error) {
      this.activeMenuItem = null
    } finally {
      this.applyState()
    }
  }

  closeMenu(event) {
    event.preventDefault()
    this.setExitTimer()
    this.stickyHeader.classList.remove('hh-sticky-header--opened')
  }

  closeOpenModals(e) {
    utils.all('hh-details-modal', this).map((element) => {
      if (element !== e.detail.value) {
        element.removeAttribute('is-open')
        if (e.detail.value.getAttribute('body-class') !== element.getAttribute('body-class')) {
          document.body.classList.remove(element.getAttribute('body-class'))
        }
      }
    })

    document.documentElement.classList.remove('mini-cart-is-active')
  }

  toggleCart(e) {
    e?.detail?.event?.preventDefault()
    utils.toggle(document.documentElement, ['mini-cart-is-active'])

    utils.all('hh-details-modal', this).map((element) => {
      console.log(element)
      element.removeAttribute('is-open')
    })
    document.body.classList.remove('overflow-hidden', 'mobile-menu--opened')
  }

  render() {
    return html`<slot
      @modalOpened="${this.closeOpenModals}"
      @toggleCart="${this.toggleCart}"
    ></slot>`
  }
}

customElements.define('hh-header', HHHeader)
